var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5111 0H2.03194C0.91265 0 0 0.893855 0 1.99345V25.6694C0 26.7724 0.91265 27.6628 2.03194 27.6628H25.5129C26.6339 27.6628 27.5517 26.7724 27.5517 25.6694V1.99345C27.5517 0.893855 26.6339 0 25.5111 0ZM8.17252 23.5722H4.08282V10.3718H8.17424V23.5722H8.17252ZM6.12853 8.56683C4.81638 8.56683 3.75736 7.50009 3.75736 6.1861C3.75736 4.87385 4.81638 3.8071 6.12853 3.8071C7.43551 3.8071 8.49797 4.87385 8.49797 6.1861C8.49797 7.50181 7.43723 8.56683 6.12853 8.56683ZM23.4758 23.5722H19.3929V17.1544C19.3929 15.6226 19.3637 13.6533 17.2697 13.6533C15.1431 13.6533 14.8194 15.32 14.8194 17.042V23.5739H10.7365V10.3718H14.6523V12.1751H14.7092C15.255 11.1377 16.5878 10.0433 18.575 10.0433C22.7095 10.0433 23.474 12.7768 23.474 16.3332V23.5722H23.4758Z",
    fill: "#F0EAE1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLi);
export default __webpack_public_path__ + "static/media/li.b7f7f19c1153d598f870ffaef32f7277.svg";
export { ForwardRef as ReactComponent };